import { Helmet } from 'react-helmet-async'
import { useIntl } from 'react-intl'
import { useActorListQuery, useFeatureFlag } from '@mwxltd/flix-api-client'
import { useListAdInsertion } from '@flix/common/domain/ads/listAdInsertion/useListAdInsertion'
import { ContentList } from '@flix/common/domain/content-lists'
import { useButtonHandlers } from '@flix/common/elements/controls'
import { MaxWidthView } from '@flix/common/elements/layout'
import { PageHeading } from '../../../components/layout/PageHeading/PageHeading'
import LoadError from '../../../containers/errors/LoadError/LoadError'
import errorMsgs from '../../../containers/errors/messages'
import { canonicalUrl } from '../../../utils/htmlHead'
import meta from '../../metaDescriptions'

const ActorsPage = ({ location }) => {
  const { getFlagValue } = useFeatureFlag()
  const bannersAdsEnabled = getFlagValue('bannerAdsEnabled')

  const intl = useIntl()

  const {
    handlers: { viewDetails },
  } = useButtonHandlers()

  const { loading, error, onFetchMore, data } = useActorListQuery({ limit: 30 })

  const list = useListAdInsertion({ list: data?.actorList, skip: !bannersAdsEnabled })

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage(meta.actorsTitle)}</title>
        <meta property="og:title" content="Actors on Flix Premiere" />
        <meta
          name="description"
          property="og:description"
          content={intl.formatMessage(meta.actors)}
        />
        <meta property="og:url" content={canonicalUrl(location)} />
        <link rel="canonical" href={canonicalUrl(location)} />
      </Helmet>

      <MaxWidthView overrideMediaWidth>
        <PageHeading>{list?.title || <>&nbsp;</>}</PageHeading>
        {error ? (
          <LoadError {...errorMsgs.loadingActors} />
        ) : (
          <ContentList
            list={list}
            onItemChosen={viewDetails}
            refreshing={loading}
            bounces={false}
            overScrollMode="never"
            onEndReachedThreshold={0.8}
            onEndReached={onFetchMore}
            maxColumns={5}
          />
        )}
      </MaxWidthView>
    </>
  )
}

export default ActorsPage
